import * as SliderPrimitive from "@radix-ui/react-slider"
import * as React from "react"
import ReactPlayer from "react-player"
import {
  aDuration,
  aMaxSeekPosition,
  aProgress,
  useAtom,
  useAtomValue,
} from "~/atoms"
import { useIsControlBarVisible } from "~/hooks"
import { cn } from "~/utils"

export default function ProgressSlider({
  className,
  videoRef,
}: {
  className?: string
  videoRef: React.RefObject<ReactPlayer>
}) {
  const [progress, setProgress] = useAtom(aProgress)
  const duration = useAtomValue(aDuration)
  const { handleInteraction } = useIsControlBarVisible()
  const maxSeekPosition = useAtomValue(aMaxSeekPosition)
  return (
    <div className={cn("group pb-1", className)}>
      <SliderPrimitive.Root
        className="relative flex w-full items-center focus-visible:ring-2 focus-visible:ring-white/10 focus-visible:ring-offset-2"
        max={duration}
        step={0.1}
        value={[progress]}
        onValueChange={(v) => {
          // Clamp seek position to maxSeekPosition (blocked by unanswered questions)
          const clampedValue = Math.min(v[0], maxSeekPosition)
          setProgress(clampedValue)
          videoRef.current?.seekTo(clampedValue, "seconds")
          handleInteraction(null)
        }}
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow scale-y-50 cursor-pointer overflow-hidden rounded-[2px] bg-white/20 transition-transform duration-200 focus-visible:scale-y-100 focus-visible:rounded-full group-hover:scale-y-100 group-hover:rounded-full">
          <SliderPrimitive.Range className="absolute h-full bg-white" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className="block h-3 w-3 scale-0 rounded-full bg-background opacity-0 ring-offset-background transition-all duration-200 focus-visible:scale-100 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent disabled:pointer-events-none disabled:opacity-50 group-hover:scale-100 group-hover:opacity-100 sm:h-4 sm:w-4" />
      </SliderPrimitive.Root>
    </div>
  )
}
